module.exports = __webpack_public_path__ + "img/iot-inspect.c3a376d2.jpg";